import Scroll from '../../pure/Scroll'
import easeScrollTo, { cancelEaseScrollTo } from '../../pure/easeScrollTo'
import store from '@/store'

export default
{
    data()
    {
        return {
            isTransition: false
        }
    },

    watch:
    {
        $route()
        {
            clearTimeout(this._to)
            this.isTransition = true
            this._to = setTimeout(() => this.isTransition = false, 1500 + 800)
        }
    },

    mounted()
    {
        this.scroll = new Scroll({
            target: this.$el
        })

        store.onSlideScroll.add(this.onSlideScroll)
    },

    destroyed()
    {
        this.scroll.dispose()

        cancelEaseScrollTo()
        store.onSlideScroll.remove(this.onSlideScroll)
    },

    methods:
    {
        onSlideScroll(y = 0)
        {
            if (y !== (this.$el.pageYOffset || this.$el.scrollTop))
            {
                easeScrollTo(y, { target: this.$el })
            }
        },

        onScrolled()
        {

        }
    }
}
